import {
    useEffect,
    useState,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

import {
    useAuth,
} from "../context/AuthContext";

import {
    getUpcomingBookings,
} from "../services/bookingService";

import UpcomingBookingHeader
    from "../components/upcomingBookings/UpcomingBookingHeader";

import UpcomingBookingCard
    from "../components/upcomingBookings/UpcomingBookingCard";

import UpcomingBookingEmpty
    from "../components/upcomingBookings/UpcomingBookingEmpty";

import {
    flattenUpcomingBookings,
} from "../utils/bookingUtils";

function UpcomingBookingsPage() {

    const {
        currentUser,
        isAuthenticated,
    } = useAuth();

    const navigate =
        useNavigate();

    const [slots, setSlots]
        = useState([]);

    const [loading, setLoading]
        = useState(true);

    useEffect(() => {

        async function loadBookings() {

            if (!currentUser) {

                setSlots([]);

                setLoading(false);

                return;
            }

            try {

                const result =
                    await getUpcomingBookings({

                        userId:
                            currentUser.uid,
                    });

                const bookings =
                    result?.orders || [];

                const flattened =
                    flattenUpcomingBookings(
                        bookings
                    );

                setSlots(flattened);

            } catch (error) {

                console.error(error);

                setSlots([]);

            } finally {

                setLoading(false);
            }
        }

        loadBookings();

    }, [currentUser]);

    /* ---------------------------------- */
    /* AUTH */
    /* ---------------------------------- */

    if (!isAuthenticated) {

        return (

            <div style={styles.authPage}>

                <div style={styles.authCard}>

                    <h2 style={styles.authTitle}>
                        Sign in to view bookings
                    </h2>

                    <button

                        onClick={() =>
                            navigate("/signin")
                        }

                        style={styles.authButton}
                    >
                        Sign In
                    </button>

                </div>

            </div>
        );
    }

    /* ---------------------------------- */
    /* LOADING */
    /* ---------------------------------- */

    if (loading) {

        return (

            <div style={styles.loading}>
                Loading upcoming bookings...
            </div>
        );
    }

    return (

        <div style={styles.page}>

            <div style={styles.container}>

                <UpcomingBookingHeader

                    count={
                        slots.length
                    }
                />

                {slots.length === 0 ? (

                    <UpcomingBookingEmpty />

                ) : (

                    <div style={styles.list}>

                        {slots.map(

                            (
                                slot,
                                index
                            ) => (

                                <UpcomingBookingCard

                                    key={
                                        `${slot.slotId}_${index}`
                                    }

                                    slot={
                                        slot
                                    }
                                />
                            )
                        )}

                    </div>
                )}

            </div>

        </div>
    );
}

const styles = {

    page: {

        minHeight: "100vh",

        padding: "40px 20px",

        background:
            "linear-gradient(111.1deg, rgb(0,40,70) -4.8%, rgb(255,229,115) 82.7%, rgb(255,203,15) 97.2%)",
    },

    container: {

        maxWidth: "1200px",

        margin: "0 auto",
    },

    list: {

        display: "flex",

        flexDirection: "column",

        gap: "24px",
    },

    loading: {

        color: "#fff",

        textAlign: "center",

        marginTop: "120px",
    },

    authPage: {

        minHeight: "100vh",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",
    },

    authCard: {

        background:
            "rgba(0,40,70,0.82)",

        padding: "40px",

        borderRadius: "24px",
    },

    authTitle: {

        color: "#fff",

        marginBottom: "24px",
    },

    authButton: {

        padding: "14px 24px",

        borderRadius: "999px",

        border: "none",

        cursor: "pointer",

        fontWeight: "700",

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",
    },
};

export default UpcomingBookingsPage;